// @ts-nocheck
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { formatEventTime, formatDateRangeLabel, formatEventTypeLabel } from "../../utils/eventUtils";

export default function EventCard({ event, onToggleSave, isSaved }) {
  const location = useLocation();
  const website = event.website || event.url || "";
  const detailId = event.primaryId || event.id;
  const detailUrl = `/events/${detailId}${location.search || ""}`;
  const isGrouped = Number(event.dayCount || 1) > 1;
  return (
    <div className="event-card">
      <div className="event-card-header">
        <div>
          <h3>{event.name}</h3>
          <div className="event-meta">
            {event.distanceLabel} | {event.city}, {event.state}
          </div>
        </div>
        <span className={`event-type ${String(event.eventType || "CONVENTION").toLowerCase()}`}>
          {formatEventTypeLabel(event.eventType || "CONVENTION")}
        </span>
      </div>

      <div className="event-info">
        <div>
          <div className="event-info-label">Date</div>
          <div className="event-info-value">
            {formatDateRangeLabel(event.groupedStartDate || event.startDateTime, event.groupedEndDate || event.endDateTime)}
          </div>
        </div>
        <div>
          <div className="event-info-label">Time</div>
          <div className="event-info-value">
            {isGrouped ? `${event.dayCount} day convention` : `${formatEventTime(event.startDateTime)} - ${formatEventTime(event.endDateTime)}`}
          </div>
        </div>
      </div>

      <div className="chip-group event-chip-group">
        {event.games.map((game) => (
          <span key={game} className="chip small">
            {game}
          </span>
        ))}
      </div>

      <div className="event-card-actions">
        {website ? (
          <a href={website} target="_blank" rel="noopener noreferrer" className="btn-primary">
            View Event Website
          </a>
        ) : (
          <button type="button" className="btn-primary" disabled title="Website unavailable">
            Website unavailable
          </button>
        )}
        <Link
          to={detailUrl}
          state={{ from: `/events${location.search || ""}`, groupedEvent: event }}
          className="btn-secondary"
        >
          Details
        </Link>
        <button
          type="button"
          className={`btn-secondary ${isSaved ? "active" : ""}`}
          onClick={() => onToggleSave(event)}
        >
          {isSaved ? "Saved" : "Save"}
        </button>
      </div>
    </div>
  );
}
